// extracted by mini-css-extract-plugin
export var button = "_m0-0";